import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';
import {
    PERSONALIZED_RERANK_TEST_NAME,
    SPONSORED_LISTINGS_TEST_NAME,
} from '../../utils/abTestHelper';
import { pageTypeConstants } from '../../constants/pageTypeConstants';
import { SortMap } from '../../constants/sbConstants';

type PersonalizedRerankProps = {
    pageType?: string | null;
    sortValue?: string | null;
};
export const personalizedRerankTracking = ({
    pageType,
    sortValue,
}: PersonalizedRerankProps): void => {
    // This if should be the same as
    // https://github.com/1stdibs/dibs-graphql/blob/release/src/schema/inventory/itemSearch/solrQueries/generateResultQuery.ts#L228
    if (
        sortValue === SortMap.relevance ||
        sortValue === SortMap.buyPageRelevance ||
        (pageType !== pageTypeConstants.BUY && sortValue === SortMap.recommended)
    ) {
        trackAbTestV2Variant(PERSONALIZED_RERANK_TEST_NAME);
    }
};

export const sponsoredListingsTracking = (): void => {
    trackAbTestV2Variant(SPONSORED_LISTINGS_TEST_NAME);
};
